<template>
 <div>
   <div class="top">
     <div  ref="searchBox">
       <div class="detailsTitle" >
          <h4>汽运单据</h4>
          <div @click="back"><i class="fa fa-reply"></i></div>
        </div>
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="110px" size="mini">
        <div class="inpBox">
               <el-form-item label="汽运单号:" prop="wayNo">
                <el-input  placeholder="" v-model="searchFrom.wayNo"></el-input>
              </el-form-item>
              <el-form-item label="拉运车号:" prop="vhcNo">
                <el-input  placeholder="" v-model="searchFrom.vhcNo"></el-input>
              </el-form-item>
              <el-form-item label="司机姓名:" prop="dirverName">
              <el-input  placeholder="" maxlength="10" v-model="searchFrom.dirverName"></el-input>
              </el-form-item>
               <el-form-item label="联系电话:" prop="dirverMobile">
              <el-input  placeholder="" maxlength="10" v-model="searchFrom.dirverMobile"></el-input>
              </el-form-item>
              <el-form-item label="创建时间:" prop="createTime">
                <el-date-picker
                  v-model="searchFrom.createTime"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
      </div>
       <div class="searchBtnBox">
         <el-form-item>
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="editFn">编辑</el-button>
          </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table"  highlight-current-row  @current-change="getDetail"  v-loading="loading"   bordersize="mini"
      height="100%" style="width: 100%" center border @row-click="handleRowClick">
         <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column fixed  type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column prop="wayNo" width="200" :show-overflow-tooltip="true"  label="汽运单号"></el-table-column>
        <el-table-column property="weight" width="100"  label="重量(吨)"></el-table-column>
        <el-table-column property="number" width="100" label="件数"></el-table-column>
         <el-table-column prop="vhcNo" width="150" label="拉运车号"></el-table-column>
        <el-table-column prop="dirverName" width="120" :show-overflow-tooltip="true" label="司机姓名"></el-table-column>
        <el-table-column prop="dirverMobile" width="150" :show-overflow-tooltip="true"  label="联系电话"></el-table-column>
       <el-table-column property="type" width="260" label="装车地址" >
          <template scope="scope">
           {{scope.row.deliverProvinceName}}{{scope.row.deliverCityName}}{{scope.row.deliverAreaName}}{{scope.row.deliverAddress}}
          </template>
        </el-table-column>
        <el-table-column property="type" width="260" label="卸车地址" >
          <template scope="scope">
            {{scope.row.receivingProvinceName}}{{scope.row.receivingCityName}}{{scope.row.receivingAreaName}}{{scope.row.receivingAddress}}
          </template>
        </el-table-column>
        <el-table-column prop="createUserName" :formatter="emptyFn" label="创建人"></el-table-column>
        <el-table-column prop="createTime" width="170" :formatter="dateTimeFormat"  label="创建时间"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div style="text-align: right;">
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
   </div>
   <div class="bottom">
     <div class="detailsTitle" >
       <h4>货物信息</h4>
    </div>
    <div class="table" :style="{height:detailsH}">
     <el-table :data="list" ref="detailTable"     bordersize="mini" class="table" height="100%"  style="width: 100%" center border >
        <el-table-column type="index" width="55" label="序号"></el-table-column>
        <el-table-column property="cargoBarcode" width="240"   label="捆包号"></el-table-column>
        <el-table-column property="productTypeName" width="100" label="货物类型"></el-table-column>
        <el-table-column property="weight" width="100" label="重量(吨)"></el-table-column>
        <el-table-column property="itemNo" width="160" :formatter="emptyFn" label="合同号"></el-table-column>
        <el-table-column property="contractNumber" :formatter="emptyFn" width="120" label="合约号"></el-table-column>
        <el-table-column property="productName" :formatter="emptyFn" label="品名"></el-table-column>
        <el-table-column property="model" width="120" :formatter="emptyFn" label="材质"></el-table-column>
         <el-table-column property="customerName" width="240"   label="客户名称"></el-table-column>
        <el-table-column prop="relCreateTime" width="160" :formatter="dateTimeFormat"  label="创建时间"></el-table-column>
    </el-table>
    </div>
   </div>
    <!-- 修改 -->
    <shipUnload :row-data="row" v-if="shipUnloadFlag" @save="HCsave" @destroy="destroy">></shipUnload>
 </div>
</template>
<script>
import { sWayList,sWayGoodsRelList,sWayUpdate } from '@/api/shipping'
import { dateTimeFormat, dateFormat, emptyFn } from '@/utils/util'
import shipUnload from '@/components/distribution/shipUnload.vue'
export default {
   components: {
    shipUnload
  },
  data () {
     var id = this.$route.query.id
    return {
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      h: 0,
      detailsH: 0,
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        businessId: id,
        wayType:2
        
      },
      id:id,
      tableList: [],
      total: 0,
      loading: 'false',
      list: [],
      goodFrom: {}, // 货物信息
      dialogGood: false,
      rules: {
        cargoBarcode: [
          { required: true, message: '请输入捆包号', trigger: 'blur' }
        ],
        productType: [
          { required: true, message: '请选择货物类型', trigger: 'blur' }
        ],
        productName: [
          { required: true, message: '请输入品名', trigger: 'blur' }
        ],
        itemNo: [
          { required: true, message: '请输入合同号', trigger: 'blur' }
        ],
        brand: [
          { required: true, message: '请输入牌号', trigger: 'blur' }
        ],
        specification: [
          { required: true, message: '请输入规格', trigger: 'blur' }
        ],
        weight: [
          { required: true, message: '请输入重量', trigger: 'blur' },
          this.rule.weight
        ]
      },
      shipUnloadFlag:false,
      row:{},
      cargoBarcode: '',
    }
  },
  created () {
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (0.7 * pH - h - 92) + 'px'
    this.detailsH = (0.3 * pH - 44) + 'px'
  },
  methods: {
    //编辑
    editFn(){
       const selectData = this.$refs.table.selection
      if(selectData.length !=1){
        this.$alert('请选择一条要操作的数据', '系统提示')
      }else{
        this.row = JSON.parse(JSON.stringify(selectData[0]))
        this.shipUnloadFlag=true
      }
    },
     HCsave (data) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      sWayUpdate(data).then(res => {
        this.$message({
          message: '操作成功',
          type: 'success'
        })
        loading.close()
        this.shipUnloadFlag = false
        this.getList(this.searchFrom)
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    destroy () {
      this.shipUnloadFlag=false
    },
    
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
   
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      sWayList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
        if (res.list.length > 0) {
          this.row = res.list[0]
          this.$refs.table.setCurrentRow(res.list[0])
          sWayGoodsRelList({ wayId: res.list[0].id,businessId:this.searchFrom.businessId }).then(res => {
            this.list = res
          })
        } else {
          this.list = []
        }
      })
    },
    getDetail (val) {
      if (val) {
        this.row = val
        sWayGoodsRelList({ wayId: val.id,businessId:this.searchFrom.businessId }).then(res => {
          this.list = res
        })
      }
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        businessId: this.id,
        wayType:2,
        createTime:null
      }
    },
    back () {
      this.$router.go(-1)// 返回上一层
    },
    closeDialog () {
      this.isEdit = true
      this.$set(this.goodFrom, 'cargoBarcode', '')
      if (this.$refs.goodFrom) {
        this.$refs.goodFrom.clearValidate()
      }
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
      width: 350px!important;
}

.addgood{
  /deep/.el-form-item__content{
    width: 193px;
  }
}
</style>
